import CardActionArea from '@mui/material/CardActionArea';

export default CardActionArea;
